import { ModeSettingEnum } from '@colonist/game-base-types';
import { GameModeDataController } from '@colonist/shared-types';
export var CKRankedState = /*#__PURE__*/ function(CKRankedState) {
    CKRankedState[CKRankedState["Locked"] = 0] = "Locked";
    CKRankedState[CKRankedState["Unlocked"] = 1] = "Unlocked";
    CKRankedState[CKRankedState["HasFreeGames"] = 2] = "HasFreeGames";
    CKRankedState[CKRankedState["HasFreeGameFromDiceRoll"] = 3] = "HasFreeGameFromDiceRoll";
    CKRankedState[CKRankedState["CanRollDice"] = 4] = "CanRollDice";
    CKRankedState[CKRankedState["WaitingToRollDice"] = 5] = "WaitingToRollDice";
    return CKRankedState;
}({});
export const CK_FREE_GAME_COUNT = 5;
export function userHasAccessToRankedCitiesAndKnights(userItems, ckTotalGameCount, abTestGroups, nextRerollAt, freePlayUntil) {
    const ckRankedState = getCKRankedState(userItems, ckTotalGameCount, abTestGroups, nextRerollAt, freePlayUntil);
    if (ckRankedState == 1) return true;
    if (ckRankedState == 2) return true;
    if (ckRankedState == 3) return true;
    return false;
}
export function shouldLockRankedCitiesAndKnights(userItems, ckTotalGameCount, abTestGroups, nextRerollAt, freePlayUntil) {
    const ckRankedState = getCKRankedState(userItems, ckTotalGameCount, abTestGroups, nextRerollAt, freePlayUntil);
    if (ckRankedState == 0) return true;
    if (ckRankedState == 5) return true;
    return false;
}
export function getCKRankedState(userItems, ckTotalGameCount, abTestGroups, nextRerollAt, freePlayUntil) {
    if (userHasNormalAccessToCitiesAndKnights(userItems)) return 1;
    if (userHasFreeCitiesAndKnightsGame(abTestGroups, ckTotalGameCount)) return 2;
    if (userHasFreeGameFromDiceRoll(abTestGroups, freePlayUntil)) return 3;
    if (userCanRollDiceForCitiesAndKnights(abTestGroups, nextRerollAt, freePlayUntil)) return 4;
    if (userIsWaitingToRollDiceForCitiesAndKnights(abTestGroups, nextRerollAt)) return 5;
    return 0;
}
function userHasNormalAccessToCitiesAndKnights(userItems) {
    if (userItems == undefined) return false;
    const citiesAndKnightsData = GameModeDataController.getModeDataForMode(ModeSettingEnum.CitiesAndKnights4P);
    if (citiesAndKnightsData == undefined) return false;
    if (userItems.membership != undefined) return true;
    if (userItems.hasAccessToPremiumMode(citiesAndKnightsData)) return true;
    return false;
}
function userHasFreeCitiesAndKnightsGame(abTestGroups, ckTotalGameCount) {
    if (abTestGroups['CK_MONETIZATION_DICE_ROLL'] == 'ONLY_DICE_ROLL') return false;
    if (ckTotalGameCount == undefined) return false;
    if (ckTotalGameCount < CK_FREE_GAME_COUNT) return true;
    return false;
}
function userHasFreeGameFromDiceRoll(abTestGroups, freePlayUntil) {
    if (abTestGroups['CK_MONETIZATION_DICE_ROLL'] == 'DEFAULT') return false;
    if (freePlayUntil == undefined) return false;
    if (freePlayUntil.getTime() > Date.now()) return true;
    return false;
}
function userCanRollDiceForCitiesAndKnights(abTestGroups, nextRerollAt, freePlayUntil) {
    if (abTestGroups['CK_MONETIZATION_DICE_ROLL'] == 'DEFAULT') return false;
    if (userHasFreeGameFromDiceRoll(abTestGroups, freePlayUntil)) return false;
    if (nextRerollAt == undefined) return true;
    if (nextRerollAt.getTime() <= Date.now()) return true;
    return false;
}
function userIsWaitingToRollDiceForCitiesAndKnights(abTestGroups, nextRerollAt) {
    if (abTestGroups['CK_MONETIZATION_DICE_ROLL'] == 'DEFAULT') return false;
    if (nextRerollAt == undefined) return false;
    if (nextRerollAt.getTime() > Date.now()) return true;
    return false;
}
